import { MediaQuery } from 'svelte/reactivity';

export const sm = new MediaQuery('width >= 640px', false);
export const md = new MediaQuery('width >= 768px', false);

export const activeSection = $state({ value: 'introduction' });
